import React from 'react';
import { Card, CardBody, Table } from 'reactstrap';
import AddressHelper from '@src/components/Elements/AddressHelper/AddressHelper';

export default props => {
  const { entity } = props;
  return (
    <Card className={'h-100 card-form'}>
      <CardBody>
        <div className={'font-md color-blue'}>
          <span className={'text-capitalize'}>
            {props.title !== undefined
              ? props.title
              : 'Borrower Contact Information'}
          </span>
          <button onClick={props.toggle}>Edit</button>
        </div>
        <div className={'pt-2 content'}>
          <Table size={'sm'} borderless>
            <tbody>
              <tr>
                <th className={'w-25'}>Email</th>
                <td>{entity.mailing_email}</td>
              </tr>
              <tr>
                <th className={'w-25'}>Phone</th>
                <td>{entity.mailing_phone}</td>
              </tr>
              <tr>
                <th className={'w-25'}>Mailing</th>
                <td>
                  {entity.mailing_address_line_1 !== null &&
                    entity.mailing_address_line_1.length > 0 && (
                      <React.Fragment>
                        {entity.mailing_address_line_1}
                        <br />
                      </React.Fragment>
                    )}
                  {entity.mailing_address_line_2 !== null &&
                    entity.mailing_address_line_2.length > 0 && (
                      <React.Fragment>
                        {entity.mailing_address_line_2}
                        <br />
                      </React.Fragment>
                    )}
                  <AddressHelper
                    city={entity.mailing_city}
                    state={entity.mailing_state}
                    zip_code={entity.mailing_zip_code}
                    address_line_1={null}
                    address_line_2={null}
                  />
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </CardBody>
    </Card>
  );
};
